// import React, { useEffect, useState, useCallback } from "react";
// import { Form, Input, Modal, Select, Button, Row, Col, Checkbox } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { getCity } from "../../store/actions/city";
// import { getPackage } from "../../store/actions/package";
// import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

// const { Option } = Select;

// const CustomerForm = ({ visible, onCreate, onCancel, record }) => {
//   const [form] = Form.useForm();
//   const [selectedCountry, setSelectedCountry] = useState(null);
//   const [selectedState, setSelectedState] = useState(null);
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);

//   const togglePasswordVisibility = () => {
//     setPasswordVisible(!passwordVisible);
//   };

//   const dispatch = useDispatch();
//   const cityList = useSelector((state) => state.city.list);
//   const packageReducer = useSelector((state) => state.packageReducer.list);

//   // Reset form
//   const resetForm = useCallback(() => {
//     form.resetFields();
//     setPasswordVisible(false);
//     setSelectedCountry(null);
//     setSelectedState(null);
//   }, [form]);

//   useEffect(() => {
//     dispatch(getCity());
//     dispatch(getPackage());
//   }, [dispatch]);

//   useEffect(() => {
//     if (visible) {
//       if (record) {
//         setIsEditing(true);
//         setTimeout(() => {
//           form.setFieldsValue({
//             ...record,
//             password: "", // Empty for update
//           });
//           setSelectedCountry(record.coId);
//           setSelectedState(record.stId);
//         }, 0);
//       } else {
//         setIsEditing(false);
//         resetForm();
//       }
//     }
//   }, [record, visible, form, resetForm]);

//   const validateGSTIN = (rule, value) => {
//     if (!value || value.trim() === "") {
//       return Promise.resolve(); // GSTIN is optional
//     }

//     // Trim the value and convert to uppercase
//     const trimmedValue = value.trim().toUpperCase();

//     // First, check if it contains any special characters (only alphanumeric allowed)
//     const hasSpecialChars = /[^A-Z0-9]/.test(trimmedValue);

//     if (hasSpecialChars) {
//       return Promise.reject(
//         new Error(
//           "GSTIN should contain only letters and numbers, no special characters!"
//         )
//       );
//     }

//     // GSTIN format: 29ABCDE1234F1Z5 (15 characters, alphanumeric)
//     const gstinRegex =
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

//     if (gstinRegex.test(trimmedValue)) {
//       return Promise.resolve();
//     }

//     return Promise.reject(new Error("Invalid GSTIN format! Format"));
//   };

//   const validateAlternativeMobile = (rule, value) => {
//     if (!value) return Promise.resolve(); // Alternative mobile is optional

//     // Check if it's exactly 10 digits
//     const mobileRegex = /^[0-9]{10}$/;

//     if (mobileRegex.test(value)) {
//       return Promise.resolve();
//     }
//     return Promise.reject(
//       new Error("Alternative mobile must be exactly 10 digits!")
//     );
//   };

//   const handleSubmit = () => {
//     form
//       .validateFields()
//       .then((values) => {
//         // Convert GSTIN to uppercase
//         if (values.gstin) {
//           values.gstin = values.gstin.toUpperCase();
//         } else {
//           values.gstin = null;
//         }

//         if (isEditing) {
//           // ✅ UPDATE MODE
//           const updatePayload = {
//             id: record.id, // Pass record ID for update
//             name: values.name,
//             mobile: values.mobile,
//             contactName: values.contactName,
//             contactMobile: values.contactMobile || null,
//             email: values.email,
//             username: values.email, // ✅ Email pass as username
//             address: values.address,
//             gstin: values.gstin,
//             cityId: values.cityId,
//           };

//           // Remove fields that shouldn't be in update
//           delete updatePayload.limit; // ✅ Remove limit
//           delete updatePayload.pId;
//           delete updatePayload.amount;
//           delete updatePayload.paymentMode;
//           delete updatePayload.paymentRec;

//           // Only include password if user wants to change it
//           if (values.password && values.password.trim() !== "") {
//             updatePayload.password = values.password;
//           }

//           onCreate(updatePayload);
//         } else {
//           // ✅ ADD MODE
//           values.amount = Number(values?.amount || 0);
//           values.username = values.email; // ✅ Email as username

//           // Remove limit from add payload too
//           delete values.limit; // ✅ Remove limit

//           onCreate(values);
//           resetForm();
//         }
//       })
//       .catch((info) => {
//         console.log("Validate Failed:", info);
//       });
//   };

//   const handleCancel = () => {
//     resetForm();
//     onCancel();
//   };

//   const formKey = isEditing ? `edit-${record?.id}` : "add-new";

//   return (
//     <Modal
//       visible={visible}
//       title={isEditing ? "Update Customer" : "Add Customers"}
//       okText="Submit"
//       cancelText="Cancel"
//       onCancel={handleCancel}
//       onOk={handleSubmit}
//       destroyOnClose={true}
//       afterClose={resetForm}
//       zIndex={9999}
//     >
//       <Form
//         key={formKey}
//         form={form}
//         layout="vertical"
//         name="customer_form"
//         preserve={false}
//       >
//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item
//               name="name"
//               label="Name"
//               rules={[{ required: true, message: "Please input the name!" }]}
//             >
//               <Input />
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               name="mobile"
//               label="Mobile"
//               rules={[
//                 { required: true, message: "Please input the mobile number!" },
//                 {
//                   pattern: /^[0-9]{10}$/,
//                   message: "Mobile number must be exactly 10 digits!",
//                 },
//               ]}
//             >
//               <Input
//                 type="number"
//                 maxLength={10}
//                 disabled={isEditing}
//                 onInput={(e) => {
//                   // Limit input to 10 digits
//                   if (e.target.value.length > 10) {
//                     e.target.value = e.target.value.slice(0, 10);
//                   }
//                 }}
//               />
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item
//               name="contactName"
//               label="Contact Name"
//               rules={[
//                 { required: true, message: "Please input the contact Name!" },
//               ]}
//             >
//               <Input />
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               name="contactMobile"
//               label="Alternative Mobile"
//               rules={[
//                 {
//                   pattern: /^[0-9]{10}$/,
//                   message: "Mobile number must be exactly 10 digits!",
//                 },
//               ]}
//             >
//               <Input
//                 type="number"
//                 placeholder="Optional"
//                 maxLength={10}
//                 onInput={(e) => {
//                   // Limit input to 10 digits
//                   if (e.target.value.length > 10) {
//                     e.target.value = e.target.value.slice(0, 10);
//                   }
//                 }}
//               />
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item
//               name="email"
//               label="Email (Username)"
//               rules={[
//                 { required: true, message: "Please input the email!" },
//                 {
//                   type: "email",
//                   message: "Please enter a valid email address!",
//                 },
//               ]}
//             >
//               <Input
//                 type="email"
//                 disabled={isEditing}
//                 autoComplete="new-email"
//               />
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               name="address"
//               label="Address"
//               rules={[{ required: true, message: "Please input the address!" }]}
//             >
//               <Input />
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               name="gstin"
//               label="GSTIN"
//               rules={[
//                 {
//                   validator: validateGSTIN,
//                 },
//               ]}
//               normalize={(value) => (value ? value.toUpperCase() : value)}
//             >
//               <Input
//                 placeholder="Optional (15 characters)"
//                 maxLength={15}
//                 onKeyPress={(e) => {
//                   // Prevent typing of special characters
//                   const char = String.fromCharCode(e.keyCode || e.which);
//                   if (!/[a-zA-Z0-9]/.test(char)) {
//                     e.preventDefault();
//                   }
//                 }}
//               />
//             </Form.Item>
//           </Col>
//           {/* ✅ Password field ONLY for ADD, NOT for UPDATE */}
//           {!isEditing && (
//             <Col span={12}>
//               <Form.Item
//                 name="password"
//                 label="Password"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Minimum 8 Characters Required!",
//                     min: 8,
//                   },
//                 ]}
//               >
//                 <Input
//                   type={passwordVisible ? "text" : "password"}
//                   autoComplete="new-email"
//                   addonAfter={
//                     <Button
//                       icon={
//                         passwordVisible ? (
//                           <EyeInvisibleOutlined />
//                         ) : (
//                           <EyeOutlined />
//                         )
//                       }
//                       onClick={togglePasswordVisibility}
//                       shape="circle"
//                       size="small"
//                     />
//                   }
//                 />
//               </Form.Item>
//             </Col>
//           )}
//         </Row>
//         <Row gutter={16}>
//           <Col span={8}>
//             <Form.Item
//               name="cityId"
//               label="City"
//               rules={[{ required: true, message: "Please select a city!" }]}
//             >
//               <Select
//                 showSearch
//                 placeholder="Select a city"
//                 filterOption={(input, option) => {
//                   return option.children
//                     .toLowerCase()
//                     .includes(input.toLowerCase());
//                 }}
//               >
//                 {cityList.map((city) => (
//                   <Option key={city.id} value={city.id}>
//                     {city.name}
//                   </Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>
//           {/* ✅ Package, Amount, Payment fields ONLY for ADD */}
//           {!isEditing ? (
//             <>
//               <Col span={8}>
//                 <Form.Item
//                   name="pId"
//                   label="Package"
//                   rules={[
//                     { required: true, message: "Please select a Package!" },
//                   ]}
//                 >
//                   <Select
//                     showSearch
//                     placeholder="Select a package"
//                     filterOption={(input, option) => {
//                       return option.children
//                         .toLowerCase()
//                         .includes(input.toLowerCase());
//                     }}
//                   >
//                     {packageReducer.map((packageComp) => (
//                       <Option key={packageComp.id} value={packageComp.id}>
//                         {packageComp.name}
//                       </Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>
//               <Col span={8}>
//                 <Form.Item
//                   name="amount"
//                   label="Amount"
//                   rules={[
//                     { required: true, message: "Please input the amount!" },
//                   ]}
//                 >
//                   <Input type="number" />
//                 </Form.Item>
//               </Col>
//             </>
//           ) : null}
//         </Row>
//         {/* ✅ Payment fields ONLY for ADD */}
//         {!isEditing ? (
//           <Row gutter={16}>
//             <Col span={8}>
//               <Form.Item
//                 name="paymentMode"
//                 label="Payment Mode"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please select a Payment Mode!",
//                   },
//                 ]}
//               >
//                 <Select showSearch placeholder="Select a payment Mode">
//                   <Option value={"Razorpay"}>Razorpay</Option>
//                   <Option value={"Cash"}>Cash</Option>
//                   <Option value={"Bank"}>Bank</Option>
//                   <Option value={"NEFT"}>NEFT</Option>
//                   <Option value={"UPI"}>UPI</Option>
//                 </Select>
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="paymentRec"
//                 label="Payment Status"
//                 valuePropName="checked"
//               >
//                 <Checkbox>Full Payment Received</Checkbox>
//               </Form.Item>
//             </Col>
//           </Row>
//         ) : null}
//       </Form>
//     </Modal>
//   );
// };

// export default CustomerForm;

import React, { useEffect, useState, useCallback } from "react";
import { Form, Input, Modal, Select, Button, Row, Col, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCity } from "../../store/actions/city";
import { getPackage } from "../../store/actions/package";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const { Option } = Select;

const CustomerForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isMobilePackage, setIsMobilePackage] = useState(false); // 🆕 Track if selected package is mobile type

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const dispatch = useDispatch();
  const cityList = useSelector((state) => state.city.list);
  const packageReducer = useSelector((state) => state.packageReducer.list);

  // Reset form
  const resetForm = useCallback(() => {
    form.resetFields();
    setPasswordVisible(false);
    setSelectedCountry(null);
    setSelectedState(null);
    setIsMobilePackage(false); // 🆕 Reset mobile package flag
  }, [form]);

  useEffect(() => {
    dispatch(getCity());
    dispatch(getPackage());
  }, [dispatch]);

  useEffect(() => {
    if (visible) {
      if (record) {
        setIsEditing(true);
        setTimeout(() => {
          form.setFieldsValue({
            ...record,
            password: "",
          });
          setSelectedCountry(record.coId);
          setSelectedState(record.stId);
        }, 0);
      } else {
        setIsEditing(false);
        resetForm();
      }
    }
  }, [record, visible, form, resetForm]);

  // 🆕 Handle package selection change
  const handlePackageChange = (value) => {
    const selectedPackage = packageReducer.find((pkg) => pkg.id === value);

    // Check if selected package name includes "mobile" (case-insensitive)
    const isMobile = selectedPackage?.name?.toLowerCase().includes("mobile");
    setIsMobilePackage(isMobile);

    // Clear subBusinessType if switching away from mobile package
    if (!isMobile) {
      form.setFieldValue("subBusinessType", undefined);
    }
  };

  const validateGSTIN = (rule, value) => {
    if (!value || value.trim() === "") {
      return Promise.resolve();
    }

    const trimmedValue = value.trim().toUpperCase();
    const hasSpecialChars = /[^A-Z0-9]/.test(trimmedValue);

    if (hasSpecialChars) {
      return Promise.reject(
        new Error(
          "GSTIN should contain only letters and numbers, no special characters!",
        ),
      );
    }

    const gstinRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (gstinRegex.test(trimmedValue)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error("Invalid GSTIN format! Format"));
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        if (values.gstin) {
          values.gstin = values.gstin.toUpperCase();
        } else {
          values.gstin = null;
        }

        if (isEditing) {
          const updatePayload = {
            id: record.id,
            name: values.name,
            mobile: values.mobile,
            contactName: values.contactName,
            contactMobile: values.contactMobile || null,
            email: values.email,
            username: values.email,
            address: values.address,
            gstin: values.gstin,
            cityId: values.cityId,
          };

          delete updatePayload.limit;
          delete updatePayload.pId;
          delete updatePayload.amount;
          delete updatePayload.paymentMode;
          delete updatePayload.paymentRec;

          if (values.password && values.password.trim() !== "") {
            updatePayload.password = values.password;
          }

          Promise.resolve(onCreate(updatePayload))
            .then((result) => {
              if (result?.code === 1) {
                resetForm();
              }
            })
            .catch((err) => {
              console.error("Edit failed:", err);
            });
        } else {
          values.amount = Number(values?.amount || 0);
          values.username = values.email;

          if (!isMobilePackage) {
            delete values.subBusinessType;
          }

          delete values.limit;

          // ✅ Only reset if onCreate succeeds
          Promise.resolve(onCreate(values))
            .then((result) => {
              if (result?.code === 1) {
                resetForm();
              }
            })
            .catch((err) => {
              // Form stays open with data intact
              console.error("Save failed:", err);
            });
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  const formKey = isEditing ? `edit-${record?.id}` : "add-new";

  return (
    <Modal
      visible={visible}
      title={isEditing ? "Update Customer" : "Add Customers"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={handleCancel}
      onOk={handleSubmit}
      destroyOnClose={true}
      afterClose={resetForm}
      zIndex={9999}
    >
      <Form
        key={formKey}
        form={form}
        layout="vertical"
        name="customer_form"
        preserve={false}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Please input the name!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="mobile"
              label="Mobile"
              rules={[
                { required: true, message: "Please input the mobile number!" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Mobile number must be exactly 10 digits!",
                },
              ]}
            >
              <Input
                type="number"
                maxLength={10}
                disabled={isEditing}
                // 🆕 Disable autofill for mobile
                autoComplete="off"
                onInput={(e) => {
                  if (e.target.value.length > 10) {
                    e.target.value = e.target.value.slice(0, 10);
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="contactName"
              label="Contact Name"
              rules={[
                { required: true, message: "Please input the contact Name!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="contactMobile"
              label="Alternative Mobile"
              rules={[
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Mobile number must be exactly 10 digits!",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Optional"
                maxLength={10}
                // 🆕 Disable autofill for alternative mobile
                autoComplete="off"
                onInput={(e) => {
                  if (e.target.value.length > 10) {
                    e.target.value = e.target.value.slice(0, 10);
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="email"
              label="Email (Username)"
              rules={[
                { required: true, message: "Please input the email!" },
                {
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input
                type="email"
                disabled={isEditing}
                autoComplete="off" // 🆕 Consistent autofill disable
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="address"
              label="Address"
              rules={[{ required: true, message: "Please input the address!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="gstin"
              label="GSTIN"
              rules={[{ validator: validateGSTIN }]}
              normalize={(value) => (value ? value.toUpperCase() : value)}
            >
              <Input
                placeholder="Optional (15 characters)"
                maxLength={15}
                onKeyPress={(e) => {
                  const char = String.fromCharCode(e.keyCode || e.which);
                  if (!/[a-zA-Z0-9]/.test(char)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          {/* 🆕 Password field with autofill disabled */}
          {!isEditing && (
            <Col span={12}>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Minimum 8 Characters Required!",
                    min: 8,
                  },
                ]}
              >
                <Input
                  type={passwordVisible ? "text" : "password"}
                  autoComplete="new-password" // 🆕 Prevents browser autofill for password
                  addonAfter={
                    <Button
                      icon={
                        passwordVisible ? (
                          <EyeInvisibleOutlined />
                        ) : (
                          <EyeOutlined />
                        )
                      }
                      onClick={togglePasswordVisibility}
                      shape="circle"
                      size="small"
                    />
                  }
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="cityId"
              label="City"
              rules={[{ required: true, message: "Please select a city!" }]}
            >
              <Select
                showSearch
                placeholder="Select a city"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {cityList.map((city) => (
                  <Option key={city.id} value={city.id}>
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {!isEditing ? (
            <>
              <Col span={8}>
                <Form.Item
                  name="pId"
                  label="Package"
                  rules={[
                    { required: true, message: "Please select a Package!" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a package"
                    onChange={handlePackageChange} // 🆕 Detect mobile package
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {packageReducer.map((packageComp) => (
                      <Option key={packageComp.id} value={packageComp.id}>
                        {packageComp.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="amount"
                  label="Amount"
                  rules={[
                    { required: true, message: "Please input the amount!" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>

              {/* 🆕 Business Sub Type — only visible when a Mobile package is selected */}
              {isMobilePackage && (
                <Col span={8}>
                  <Form.Item
                    name="subBusinessType"
                    label="Business Sub Type"
                    rules={[
                      {
                        required: true,
                        message: "Please select a Business Sub Type!",
                      },
                    ]}
                  >
                    <Select placeholder="Select sub type">
                      <Option value={1}>Mobile</Option>
                      <Option value={2}>Electronic</Option>
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </>
          ) : null}
        </Row>

        {!isEditing ? (
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="paymentMode"
                label="Payment Mode"
                rules={[
                  {
                    required: true,
                    message: "Please select a Payment Mode!",
                  },
                ]}
              >
                <Select showSearch placeholder="Select a payment Mode">
                  <Option value={"Razorpay"}>Razorpay</Option>
                  <Option value={"Cash"}>Cash</Option>
                  <Option value={"Bank"}>Bank</Option>
                  <Option value={"NEFT"}>NEFT</Option>
                  <Option value={"UPI"}>UPI</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="paymentRec"
                label="Payment Status"
                valuePropName="checked"
              >
                <Checkbox>Full Payment Received</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        ) : null}
      </Form>
    </Modal>
  );
};

export default CustomerForm;
